import { EnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { QrCodesEffects } from './effects/qr-codes.effects';
import { QR_CODES_FEATURE_KEY } from './keys';
import { qrCodesReducer } from './reducers/qr-codes.reducer';

export function provideQrCodesStore(): EnvironmentProviders[] {
    return [provideState(QR_CODES_FEATURE_KEY, qrCodesReducer), provideEffects(QrCodesEffects)];
}
